import { onReady } from '../base/init.js';
import { loadSwiper } from '../base/swiper-lazy.js';

onReady(() => {
  initLogolineSlider();
});

function initLogolineSlider() {
  const el = document.getElementById('logolineSlider');
  if (!el || el.swiperInstance) return;

  loadSwiper().then((Swiper) => {
    if (!Swiper || el.swiperInstance) return;
    initSlider(el, Swiper);
  });
}

function initSlider(el, Swiper) {
  const swiper = new Swiper(el, {
    slidesPerView: 5,
    spaceBetween: 10,
    loop: true,
    loopedSlides: 17,
    speed: 5000,
    allowTouchMove: false,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 8,
        spaceBetween: 10,
      },
      1200: {
        slidesPerView: 10,
        spaceBetween: 10,
      },
    },
  });

  el.swiperInstance = swiper;
}
